import React, { ReactElement } from 'react';
import { CountriesData, Country, CountryItem } from '../data';
import CountriesList from './CountriesList';
import CountriesListItem from './CountriesListItem';
import { useSearchTerm } from '../hooks/useSearchTerm';

const CountriesListContainer = (): ReactElement => {
  const { foundTerms, isSearchActive } = useSearchTerm();

  const renderElements = () => {
    if (isSearchActive) {
      return foundTerms.map((item: CountryItem) => {
        return (
          <CountriesListItem key={`${item.id}_${item.name}`} name={item.name} url={item.url}/>
        );
      });
    } else {
      return CountriesData.map((item: Country) => {
        if (!item.countries.length) return;
        return (
          <CountriesList
            key={item.id}
            id={item.id}
            region={item.region}
            countries={item.countries}
          />
        );
      });
    }
  };

  return (
    <div className="freight-forwarder__countries-list-container">
      {renderElements()}
    </div>
  );
};

export default CountriesListContainer;